import { useCallback, useEffect, useState } from "react";

import type { CrremSettings } from "../model/types";

import {
  readEnergyAnalysisSettings,
  subscribeEnergyAnalysisSettings,
  writeEnergyAnalysisSettings,
} from "../lib/crremSettingsStorage";

export const useCrremSettings = (projectId: string) => {
  const [settings, setSettings] = useState(() => readEnergyAnalysisSettings(projectId));

  useEffect(() => {
    setSettings(readEnergyAnalysisSettings(projectId));
    return subscribeEnergyAnalysisSettings(projectId, setSettings);
  }, [projectId]);

  const saveSettings = useCallback(
    (next: CrremSettings) => {
      setSettings(writeEnergyAnalysisSettings(projectId, next));
    },
    [projectId]
  );

  return { saveSettings, settings };
};
